import { render } from "./new-order.vue?vue&type=template&id=5d1505f0"
import script from "./new-order.vue?vue&type=script&lang=js"
export * from "./new-order.vue?vue&type=script&lang=js"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__